import { render } from "./AlarmProfileIndex.vue?vue&type=template&id=69d0ae2a"
import script from "./AlarmProfileIndex.vue?vue&type=script&lang=js"
export * from "./AlarmProfileIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__